// src/hooks/useFx.ts
import { useQuery } from "@tanstack/react-query";

type Rates = Record<string, number>;

export function useFx(base = "USD") {
  return useQuery<Rates>({
    queryKey: ["rates", base],
    queryFn: async () => {
      const res = await fetch(
        `https://api.exchangerate.host/latest?base=${base}`
      );
      if (!res.ok) throw new Error("FX fetch failed");
      const data = await res.json();
      return (data.rates || {}) as Rates;
    },
    staleTime: 1000 * 60 * 55,   // treat as fresh for 55 min
    gcTime: 1000 * 60 * 60,   // garbage-collect after 1 h
    refetchOnWindowFocus: false,
  });
}
